import { render, staticRenderFns } from "./AccountingReportsCardexQtyAmountComponent.vue?vue&type=template&id=9048a45c&"
import script from "./AccountingReportsCardexQtyAmountComponent.vue?vue&type=script&lang=js&"
export * from "./AccountingReportsCardexQtyAmountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports